import { FormattedMessage } from 'react-intl';

import { Tag, TagType } from 'ui-components/components/tag';

import { statusMessages } from './messages';
import { AsnStatus } from '../../constants';

/**
 * Maps a status to the appropriate tag type
 * @param {string} status - The status to map
 * @returns {string} The appropriate tag type for the status
 */
const getTagTypeByStatus = (status) => {
  switch (status) {
    case AsnStatus.Awaiting:
    case AsnStatus.InTransit:
    case AsnStatus.Processing:
    case AsnStatus.Arrived:
    case AsnStatus.PartiallyArrived:
    case AsnStatus.PartiallyArrivedAtHub:
    case AsnStatus.ArrivedAtHub:
    case AsnStatus.ProcessingAtHub:
    case AsnStatus.InternalTransfer:
      return TagType.Info;
    case AsnStatus.Completed:
    case AsnStatus.Received:
      return TagType.Success;
    case AsnStatus.Incomplete:
      return TagType.Warning;
    case AsnStatus.Cancelled:
      return TagType.Alert;
    default:
      return TagType.Neutral;
  }
};

/**
 * @param {object} props
 * @param {string} props.status - The Advanced Shipping Notice status
 * @param {string} props.className
 * @returns {React.ReactElement}
 */
export const AsnStatusTag = ({ className = '', status }) => {
  const tagType = getTagTypeByStatus(status);

  return <Tag className={className} message={<FormattedMessage {...statusMessages[status.toLowerCase()]} />} type={tagType} />;
};
